import { Routes } from '@angular/router';
import { LandingPageComponent } from './features/landing/pages/landing-page/landing-page.component';
import { WizardLayoutComponent } from './features/wizard/layout/wizard-layout/wizard-layout.component';
import { DentistDemographicsComponent } from './features/wizard/pages/dentist-demographics/dentist-demographics.component';
import { DentalCredentialsComponent } from './features/wizard/pages/dental-credentials/dental-credentials.component';
import { WorkHistoryComponent } from './features/wizard/pages/work-history/work-history.component';
import { WorkHistoryFormComponent } from './features/wizard/pages/work-history-form/work-history-form.component';
import { AttestationsComponent } from './features/wizard/pages/attestations/attestations.component';
import { SignedDocumentsComponent } from './features/wizard/pages/signed-documents/signed-documents.component';
import { PdfSigningComponent } from './features/wizard/pages/pdf-signing/pdf-signing.component';
import { LocationComponent } from './features/wizard/pages/location/location.component';
import { AddLocationComponent } from './features/wizard/pages/add-location/add-location.component';
import { SignupComponent } from './features/auth/signup/signup.component';
import { ConfirmationComponent } from './features/wizard/pages/confirmation/confirmation.component';
import { LoginComponent } from './login/login.component';
import { ProcessingComponent } from './features/popups/processing/processing.component';
import { AdminComponent } from './features/admin/admin.component';
import { AuthGuard } from './guard/auth.guard';
import { MsalGuard } from '@azure/msal-angular';
import { CanDeactivateGuard } from './shared/services/can-deactivate.service';
import { SearchTinComponent } from './features/wizard/pages/add-location/search-tin/search-tin.component';
import { CreateTinComponent } from './features/wizard/pages/add-location/create-tin/create-tin.component';

export const routes: Routes = [
  { path: '', 
    loadComponent:()=> import('./login/login.component').then(m=> m.LoginComponent) },
  { path: 'login', loadComponent:()=> import('./login/login.component').then(m=> m.LoginComponent) },
  {
    path: 'landing',
    component: LandingPageComponent
  },
  {
    path: 'signup',
    component: SignupComponent
  },
  {
    path: 'admin',
    component: AdminComponent
  },
  { path: 'processing', component: ProcessingComponent },
  {
    path: 'credentialing',
    canActivate: [AuthGuard],
    component: WizardLayoutComponent,
    children: [
      { path: '', component: DentistDemographicsComponent },
      { path: 'information', component: DentistDemographicsComponent },
      { path: 'credentials', component: DentalCredentialsComponent },
      { path: 'work-history', component: WorkHistoryComponent },
      { path: 'work-history/add', component: WorkHistoryFormComponent },
      { path: 'work-history/edit/:id', component: WorkHistoryFormComponent },
      { path: 'attestations', component: AttestationsComponent },
      { path: 'sign-documents', component: SignedDocumentsComponent },
      { path: 'sign-documents/sign', component: PdfSigningComponent },
      { path: 'locations', component: LocationComponent },
      { path: 'locations/add', component: AddLocationComponent,canDeactivate: [CanDeactivateGuard], },
      { path: 'confirmation', component: ConfirmationComponent },
      { path: 'search-tin', component: SearchTinComponent },
      { path: 'locations/add-tin', component: CreateTinComponent,canDeactivate: [CanDeactivateGuard], },
      { path: 'confirmation', component: ConfirmationComponent }
    ]
  },
  { path: '**', redirectTo: '' }
];
